import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "../component/Header.js/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
    const MainBox = styled.div`
    height: fit-content;
    padding: 4rem 4rem;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    @media only screen and (max-width: 1220px) {
      width: 100%;
      padding: 1rem;
    }
  `;

    return (
        <>
            <Navbar />
            <MainBox>
                <h1>Privacy Policy – Samriddhi India</h1>

                <p>Welcome to Samriddhi India!</p>

                <p>At Samriddhi India, we value your privacy and are committed to protecting your personal data. This Privacy Policy, together with our Terms of Use, explains how we collect, use, store, and share your information when you shop for our clothing, ethnic wear, kurtas, workwear, and women’s fashion online. By using our website or placing an order, you agree to the practices described in this Privacy Policy.</p>

                <p>This policy is published in compliance with the Information Technology Act, 2000, and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011.</p>

                <h2>Information We Collect</h2>
                <ul>
                    <li><strong>Personal Details:</strong> Your name, email address, phone number, gender, billing/shipping address.</li>
                    <li><strong>Order Information:</strong> Purchase history, payment details, order preferences, product size/fit details.</li>
                    <li><strong>Technical Data:</strong> Your IP address, browser type, and cookies to help improve your online shopping experience.</li>
                    <li><strong>Feedback & Reviews:</strong> Information shared through product reviews, feedback forms, or customer service communication.</li>
                </ul>

                <h2>How We Use Your Information</h2>
                <ul>
                    <li>Process your orders for kurtas, ethnic wear, and trendy clothing.</li>
                    <li>Personalize your shopping experience by showing you products relevant to your style.</li>
                    <li>Provide order updates, tracking details, and faster delivery services.</li>
                    <li>Notify you about new collections, offers, and discounts on women’s fashion and ethnic clothing.</li>
                    <li>Improve our website design, navigation, and user experience.</li>
                    <li>Detect and prevent fraudulent or unauthorized transactions.</li>
                </ul>

                <h2>Cookies & Online Tracking</h2>
                <p>Our website uses cookies to remember your preferences such as size, color, and style filters. Cookies help us offer a more seamless experience while shopping for women’s clothing, ethnic wear, and workwear online.</p>
                <p>You may choose to disable cookies in your browser, but this may limit certain website features like faster checkout or product recommendations.</p>

                <h2>Sharing of Your Data</h2>
                <p>We do not sell your personal information. However, we may share your data with:</p>
                <ul>
                    <li><strong>Courier & Delivery Partners:</strong> To ensure timely delivery of your orders.</li>
                    <li><strong>Payment Gateways:</strong> For secure online transactions.</li>
                    <li><strong>Marketing & Analytics Partners:</strong> To improve our ads, offers, and clothing collections shown to you.</li>
                    <li><strong>Legal Authorities:</strong> When required to comply with applicable law or prevent fraud.</li>
                </ul>
                <p>All partners we work with are required to maintain strict confidentiality and use your data only for authorized purposes.</p>

                <h2>Data Security</h2>
                <p>We use SSL encryption, secure servers, and industry-standard security measures to protect your personal data. Your payment details are processed through secure payment gateways.</p>

                <h2>Your Rights</h2>
                <p>You have full control over your data. You can:</p>
                <ul>
                    <li>Access and update your personal information anytime by logging into your account.</li>
                    <li>Request deletion of your account and personal data.</li>
                    <li>Opt-out of marketing emails and SMS updates.</li>
                </ul>
                <p>To exercise these rights, please contact us at <a href="mailto:care@samriddhiindia.com">care@samriddhiindia.com</a>.</p>

                <h2>Data Retention</h2>
                <p>We retain your personal data for as long as needed to fulfill your orders, comply with legal obligations, and improve our services.</p>

                <h2>Changes to This Policy</h2>
                <p>Samriddhi India may update this Privacy Policy from time to time. Changes will be posted on this page, and we encourage you to review it periodically to stay informed.</p>

                <h2>Contact Us</h2>
                <p>For questions, concerns, or feedback about this Privacy Policy, please reach out to our Grievance Officer:</p>
                <p>Email: <a href="mailto:care@samriddhiindia.com">care@samriddhiindia.com</a><br />
                    Phone: <a href="tel:+919520782777">+91 95207 82777</a> (Customer Support, Mon-Sat, 10 AM – 6 PM)</p>
            </MainBox>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
